import { HStack, Icon, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import { useSearchBox } from "react-instantsearch";

export default function CampaignSearchInput() {
  const { query, refine } = useSearchBox();
  return (
    <InputGroup maxW={{ base: "100%", sm: "320px" }} flex="1" minW="200px">
      <InputLeftElement pointerEvents="none" color="gray.400">
        <Icon as={FiSearch} boxSize={4} />
      </InputLeftElement>
      <Input
        placeholder="Search by name"
        value={query}
        onChange={(e) => refine(e.target.value)}
        size="md"
        bg="white"
        borderColor="gray.200"
        _placeholder={{ color: "gray.500" }}
      />
    </InputGroup>
  );
}
